import cn from 'classnames';
import { useId } from 'react';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

import { Check } from '@/components/Icons';
import { DataFromFormInputs } from '@/types';
// import { InfoIcon } from 'src/components/Icons/InfoIcon';
import { valSchema } from '@/utils/valSchema';

import s from './Checkbox.module.scss';

interface CheckBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  errors: FieldErrors<DataFromFormInputs>;
  name: string;
  disabled?: boolean;
  register: UseFormRegister<FieldValues>;
  required: boolean;
  checked?: boolean;
  label: string;
  infoText?: string;
  onCustomChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  variant?: 'base' | 'dark' | 'purple';
}

const Checkbox = ({
  className,
  errors,
  name,
  disabled,
  register,
  checked,
  label,
  required,
  variant = 'base',
  onCustomChange,
  ...rest
}: CheckBoxProps) => {
  const { onChange, ...restOptions } = {
    ...register(name, {
      required: !disabled && required ? valSchema.default?.required : false,
    }),
  };

  const id = useId();

  return (
    <div
      className={cn(s.root, className, {
        [s.error]: errors && errors[name],
        [s.dark]: variant === 'dark',
        [s.purple]: variant === 'purple',
      })}
    >
      <input
        data-qa="checkbox"
        checked={checked}
        data-click="funnel-form-input"
        className={s.input}
        id={name + id}
        type="checkbox"
        disabled={disabled}
        {...rest}
        {...restOptions}
        onChange={(event) => {
          onCustomChange && onCustomChange(event), onChange(event);
        }}
      />
      <div className={s.wrapper}>
        <label className={s.label} htmlFor={name + id}>
          <Check className={s.icon} />
          <span
            className={s.labelText}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        </label>
      </div>
      {errors && errors[name] && (
        <span className={s.errorText}>{errors[name]?.message}</span>
      )}
    </div>
  );
};

export { Checkbox };
